import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0 23px;
  border-bottom: 1px solid ${theme.backgrounds.backgroundOne};
`

export const groupTitle: Interpolation<Theme> = (theme) => css`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const items: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
`

export const item: (props: { isActive?: boolean; isDisabled?: boolean; isCurrent?: boolean }) => Interpolation<Theme> =
  ({ isActive, isDisabled, isCurrent }) =>
  (theme) =>
    css`
      min-height: 44px;
      display: flex;
      gap: 10px;
      align-items: center;
      padding: 10px;
      border-radius: 14px;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: ${theme.typographyColors.typographyTwo};
      text-decoration: none;

      & > div {
        flex: 1;
      }

      > svg {
        min-width: 24px;
        min-height: 24px;
      }

      .arrow-icon {
        display: ${isActive ? 'block' : 'none'};
      }

      :hover {
        background: ${theme.backgrounds.backgroundThree};

        .arrow-icon {
          display: block;
        }
      }

      ${isDisabled &&
      css`
        cursor: not-allowed;
      `}

      ${isCurrent &&
      css`
        background: ${theme.backgrounds.backgroundFive};
      `}
    `

export const menuItemTitle: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1)};
  justify-content: flex-start;

  span {
    width: max-content;
  }
`

export const universalLabel: Interpolation<Theme> = (theme) => css`
  flex-grow: 0;

  padding: ${theme.spacing(0.75)};
  border-radius: 8px;

  line-height: 8px;

  background-color: ${theme.colors.typographyTwo};
`
